<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="grid">
    <b-row>
      <b-col
        cols="12"
        xl="6"
        lg="6"
        md="12"
        v-for="(simulation, index) in simulations"
        :key="index"
      >
        <simulation-card
          :id="`sim-${simulation.name}`"
          :simulation="simulation"
          :can-validate-simulation="canValidateSimulation"
        ></simulation-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import SimulationCard from "./SimulationCard.vue";
import { routeUtils } from "@/shared/route.util";
import { constants } from "@/shared/constants";
export default {
  name: "SimulationGrid",
  props: ["simulations"],
  components: { SimulationCard },
  computed: {},
  data() {
    return {
      canValidateSimulation: false
    };
  },
  mounted() {
    this.canValidateSimulation = routeUtils.isAllowed(
      constants.VALIDATE_SIMULATION
    );
  }
};
</script>

<style lang="scss">
#SimulationsList {
  .status {
    padding-top: 0;
    padding-bottom: 40px;
    @media (max-width: 768px) {
      padding-bottom: 30px;
    }
  }
  .volums {
    border-right: 1px solid #dee2e6;
    @media (max-width: 768px) {
      border-bottom: 1px solid #dee2e6;
      border-right: none;
      padding-bottom: 25px;
    }
    .volume {
      line-height: 22px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .demande-button {
    background-color: #7ab145;
    color: #fff;
    border: 1px solid #7ab145;
    border-radius: 30px;
    padding: 6px 15px;
    font-size: 15px;
    @media (max-width: 768px) {
      margin-top: 20px;
    }
  }
  .in-progress-button {
    background-color: transparent;
    color: #7ab145;
  }
  .valuation-result {
    display: flex;
    align-items: baseline;
    justify-content: center;
    .valuation-label {
      margin: 0;
    }
    @media (max-width: 768px) {
      padding-top: 20px;
    }
    .valuation-value {
      padding-left: 5px;
    }
  }
}
</style>
